import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '选择框',
        fieldKey: 'no',
        fieldName: '编号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: true,
          multiple: false,
          clearable: true,
          isHide: false
        }
      }, {
        componentType: 'el-autocomplete',
        componentName: '选择框',
        fieldKey: 'brand',
        fieldName: '品牌',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'business/actions/history/brand?value=',
          pickerType: '',
          filterable: true,
          selectType: 2 // 1本地2远程
        }
      }, {
        componentType: 'el-autocomplete',
        componentName: '选择框',
        fieldKey: 'name',
        fieldName: '名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'business/actions/history/name?value=',
          pickerType: '',
          filterable: true,
          selectType: 2 // 1本地2远程
        }
      }, {
        componentType: 'el-autocomplete',
        componentName: '选择框',
        fieldKey: 'model',
        fieldName: '型号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'business/actions/history/model?value=',
          pickerType: '',
          filterable: true,
          selectType: 2 // 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'serial',
        fieldName: '序列号',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'amount',
        fieldName: '数量',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'unitId',
        fieldName: '单位',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'materialUnit/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'type',
        fieldName: '业务类型',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          uniqueFieldKey: 'businessType',
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'BusinessType',
          pickerType: '',
          filterable: true,
          selectType: 1 // 1本地2远程
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'urgentId',
        fieldName: '紧急程度',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'urgency/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'repairType',
        fieldName: '维修类型',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'RepairType',
          pickerType: '',
          filterable: true,
          selectType: 1 // 1本地2远程
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'businessClassId',
        fieldName: '业务分类',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isHide: true,
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'businessClass/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'outsourceCompanyId',
        fieldName: '外包公司',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isHide: true,
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'outsourceCompany/dropdown?',
          pickerType: '',
          filterable: true,
          remote: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'outsourceCompanyContactId',
        fieldName: '外包联系',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isHide: true,
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'outsourceCompanyContact/page',
          pickerType: '',
          filterable: true,
          params: {
            outsourceCompanyId: ''
          },
          selectType: 3 // 1本地2远程
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'engineerIds',
        fieldName: '工程师',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isHide: true,
          collapseTags: true,
          isDisabled: false,
          multiple: true,
          clearable: true,
          url: 'user/dropdown/engineers?all=true',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-upload',
        componentName: '下拉选择',
        fieldKey: 'appearancePictures',
        fieldName: '外观图片',
        placeholder: '',
        value: [],
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          width: '100%',
          multiple: false,
          clearable: true
        }
      }, {
        componentType: 'el-textarea',
        componentName: '输入框',
        fieldKey: 'fault',
        fieldName: '故障描述',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false,
          width: '100%',
          isHide: false
        }
      }
    ]
  }, {
    title: '联系人信息',
    type: 1,
    labelClass: 'green',
    labelName: '联',
    formList: [
      {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'customerCompanyId',
        fieldName: '客户公司',
        placeholder: '',
        value: '',
        option: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          label: 'name',
          url: 'customerCompany/dropdown',
          filterable: true,
          selectType: 2, // 1本地2远程
          remote: true
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'customerContactIds',
        fieldName: '联系人',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: true,
          clearable: true,
          url: 'customerCompanyContact/dropdown',
          pickerType: '',
          filterable: true,
          // selectType: 2, // 1本地2远程
          // remote: true,
          mode: 'marketUser',
          params: {
            companyId: ''
          }
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'salesManId',
        fieldName: '业务员',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }
      //  {
      //   componentType: 'el-input',
      //   componentName: '输入框',
      //   fieldKey: 'mark',
      //   fieldName: '备注',
      //   placeholder: '',
      //   value: '',
      //   rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
      //   config: {
      //     isDisabled: false,
      //     clearable: true,
      //     url: '',
      //     filterable: false
      //   }
      // }
    ]
  }
]
